<template>
  <div class="set-seal">
    <div class="row">
      <div class="row-title">发起人</div>
      <div class="row-body">
        <el-button
          type="text"
          v-if="data.startUserInfo && !data.startUserInfo.name"
          @click="addStartUser"
        >
          添加发起人
        </el-button>
        <div v-else class="user-item">
          <span v-tip>
            {{
              extra.valueMap.startUserInfo.name.arr[0].label ||
                extra.valueMap.startUserInfo.name.arr[0].text
            }}
          </span>
          <i
            class="el-icon-edit-outline user-operation"
            style="font-size: 15px"
            @click="editStartUser"
          ></i>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="row-title">
        签署人
        <el-button type="text" v-if="!_.isEmpty(data.signParams)" @click="addSignUser">
          添加签署人
        </el-button>
      </div>
      <div class="row-body">
        <el-button type="text" v-if="_.isEmpty(data.signParams)" @click="addSignUser">
          添加签署人
        </el-button>
        <div v-else v-for="(signUser, index) in data.signParams" :key="index" class="user-item">
          <span v-tip>
            {{
              extra.valueMap.signParams[index].name.arr[0].label ||
                extra.valueMap.signParams[index].name.arr[0].text
            }}
          </span>
          <i
            class="el-icon-edit-outline user-operation"
            style="font-size: 15px"
            @click="editSignUser(signUser, index)"
          ></i>
          <i
            class="el-icon-delete user-operation"
            style="font-size: 15px"
            @click="delSignUser(index)"
          ></i>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="row-title">签署文件</div>
      <control-value
        v-model="extra.valueMap['attachment']"
        :control="{ _type: 'file', oneFlag: true }"
        @input-val="setVal('attachmentId', $event)"
        :group-list="groupList"
        class="row-body"
      ></control-value>
    </div>
    <sign-user-dialog
      ref="signUser"
      :operation="operation"
      :sign-user="signUser"
      :extra="extra"
      :index="index"
      :group-list="groupList"
      @submit="setSignUser"
      :key="'sign' + index"
    ></sign-user-dialog>
    <start-user-dialog
      ref="startUser"
      :operation="operation"
      :start-user="data.startUserInfo"
      :extra="extra"
      :group-list="groupList"
      @submit="setStartUser"
      key="start"
    ></start-user-dialog>
  </div>
</template>

<script>
import ControlValue from "@/components/Workflow/ControlValue"
import SignUserDialog from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/SignUserDialog"
import StartUserDialog from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/StartUserDialog"

export default {
  name: "set-seal",
  components: { StartUserDialog, SignUserDialog, ControlValue },
  props: {
    data: Object,
    extra: Object,
    groupList: Array
  },
  data() {
    return {
      operation: "addSignUser",
      startUser: {
        name: "",
        number: "",
        telephone: "",
        type: ""
      },
      signUser: {
        userInfo: {
          name: "",
          number: "",
          telephone: "",
          type: ""
        },
        signPosition: {
          page: 1,
          x: 1,
          y: 1
        }
      },
      index: 0
    }
  },
  methods: {
    setVal(attr, val) {
      this.data[attr] = val ? val[0].id : ""
    },
    addSignUser() {
      this.operation = "addSignUser"
      this.signUser = this.$options.data().signUser
      this.index = this.data.signParams.length
      this.$nextTick(() => {
        this.$refs.signUser?.open()
      })
    },
    editSignUser(item, index) {
      this.operation = "editSignUser"
      this.signUser = item
      this.index = index
      this.$nextTick(() => {
        this.$refs.signUser?.open()
      })
    },
    delSignUser(index) {
      this.data.signParams.splice(index, 1)
      this.extra.valueMap.signParams.splice(index, 1)
    },
    setSignUser(signUser) {
      switch (this.operation) {
        case "addSignUser":
          this.data.signParams.push(signUser)
          break
        case "editSignUser":
          this.data.signParams.splice(this.index, 1, signUser)
          break
      }
    },
    addStartUser() {
      this.operation = "addStartUser"
      this.data.startUserInfo = this.$options.data().startUser
      this.$nextTick(() => {
        this.$refs.startUser?.open()
      })
    },
    editStartUser() {
      this.operation = "editStartUser"
      this.$nextTick(() => {
        this.$refs.startUser?.open()
      })
    },
    setStartUser(startUser) {
      this.data.startUserInfo = startUser
    }
  }
}
</script>

<style lang="scss" scoped>
.set-seal {
  .row {
    font-size: 13px;
    padding-bottom: 15px;
    .row-title {
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .row-body {
      margin-top: 10px;
      .user-item {
        line-height: 36px;
        height: 36px;
        font-size: 13px;
        align-items: center;
        display: flex;
        background-color: #f8f8f8;
        border-radius: 4px;
        padding: 0 10px;
        margin-bottom: 4px;
        .user-operation {
          margin-right: 10px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
